import { useState } from 'react'
import { Botao } from '../../../components/Botao'
import { Dialogo } from '../../../components/Dialogo'
import { CampoDeTextoLongo } from '../../../components/campos'

/**
 * Pede um texto obrigatório antes de um ato que fica registrado.
 *
 * Reabrir uma competência e dispensar sanção têm a mesma forma: são atos administrativos que só
 * valem com a justificativa escrita, e ela vai para a trilha. Um diálogo só para os dois porque a
 * regra é a mesma — e porque duas cópias divergiriam justamente na validação do vazio, que é o
 * ponto todo.
 *
 * O botão de confirmar fica desabilitado enquanto o texto não alcançar `minimo` caracteres úteis.
 * Não é substituto da validação do servidor (que continua lá): é não deixar a pessoa clicar para
 * receber uma recusa que a tela já sabia que viria.
 *
 * `minimo` é 1 por omissão — o comportamento de sempre, "não pode estar em branco". A discordância
 * sobre um parecer pede 10, e o número não é escolha de tela: é o CHECK que o banco impõe (V39).
 * Um piso na tela que fosse menor que o do banco só produziria o erro mais tarde; maior, recusaria
 * o que o banco aceita.
 *
 * @param props título, ajuda, rótulo do campo, o piso do texto e o que fazer ao confirmar
 * @returns o diálogo
 */
export function DialogoDeTexto({
  titulo,
  ajuda,
  rotulo,
  minimo = 1,
  aviso,
  aoConfirmar,
  aoFechar,
}: {
  titulo: string
  ajuda: string
  rotulo: string
  /** Quantos caracteres úteis o texto precisa ter. O padrão é 1: "não pode estar em branco". */
  minimo?: number
  /** O que dizer enquanto o texto for curto demais. Sem ele, o botão desabilitado não se explica. */
  aviso?: string
  aoConfirmar: (texto: string) => void
  aoFechar: () => void
}) {
  const [texto, setTexto] = useState('')
  const curto = texto.trim().length < minimo

  return (
    <Dialogo titulo={titulo} aoFechar={aoFechar}>
      <div className="space-y-4">
        <p className="max-w-prose text-sm text-slate-600">{ajuda}</p>
        <CampoDeTextoLongo rotulo={rotulo} value={texto} onChange={(e) => setTexto(e.target.value)} rows={4} />
        {/* O aviso só aparece depois que a pessoa começou a escrever: exibi-lo no campo vazio
            transformaria a abertura do diálogo numa repreensão. */}
        {aviso && curto && texto.length > 0 && <p className="text-sm text-slate-500">{aviso}</p>}
        <div className="flex flex-wrap gap-2">
          <Botao aparencia="primario" onClick={() => aoConfirmar(texto.trim())} disabled={curto}>
            Confirmar
          </Botao>
          <Botao onClick={aoFechar}>Cancelar</Botao>
        </div>
      </div>
    </Dialogo>
  )
}
